export default __webpack_public_path__ + "static/media/alteredIcon.0fdb6b12.png";